import { render, staticRenderFns } from "./importTips.vue?vue&type=template&id=23e3c98a&scoped=true&"
import script from "./importTips.vue?vue&type=script&lang=js&"
export * from "./importTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e3c98a",
  null
  
)

export default component.exports